var _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.842 13.957C13.531 13.957 16.684 14.516 16.684 16.749C16.684 18.982 13.552 19.557 9.842 19.557C6.152 19.557 3 19.003 3 16.769C3 14.535 6.131 13.957 9.842 13.957Z",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84199 10.77C7.41999 10.77 5.45599 8.807 5.45599 6.385C5.45599 3.963 7.41999 2 9.84199 2C12.263 2 14.227 3.963 14.227 6.385C14.236 8.798 12.286 10.761 9.87299 10.77H9.84199Z",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3693 14.531L21.0455 13.969C20.7715 13.4936 20.1644 13.3296 19.6883 13.6024C19.4617 13.7359 19.1913 13.7738 18.9367 13.7077C18.6821 13.6416 18.4642 13.4769 18.3312 13.25C18.2456 13.1058 18.1996 12.9415 18.1978 12.7738C18.2056 12.5049 18.1041 12.2444 17.9166 12.0515C17.7292 11.8587 17.4716 11.7499 17.2026 11.75H16.5502C16.2867 11.75 16.034 11.855 15.8482 12.0418C15.6623 12.2286 15.5585 12.4817 15.5597 12.7452C15.5519 13.2893 15.1086 13.7262 14.5645 13.7262C14.3968 13.7244 14.2325 13.6785 14.0883 13.5929C13.6122 13.32 13.0051 13.4841 12.7312 13.9595L12.3836 14.531C12.1099 15.0058 12.2717 15.6125 12.7455 15.8881C13.0534 16.0659 13.2431 16.3944 13.2431 16.75C13.2431 17.1056 13.0534 17.4341 12.7455 17.6119C12.2723 17.8856 12.1104 18.4909 12.3836 18.9643L12.7121 19.531C12.8405 19.7626 13.0558 19.9335 13.3105 20.0058C13.5652 20.0782 13.8383 20.0461 14.0693 19.9167C14.2963 19.7842 14.5669 19.7479 14.8209 19.8158C15.0748 19.8838 15.2911 20.0504 15.4217 20.2786C15.5072 20.4228 15.5532 20.5871 15.555 20.7548C15.555 21.3044 16.0006 21.75 16.5502 21.75H17.2026C17.7504 21.75 18.1952 21.3073 18.1978 20.7595C18.1966 20.4952 18.301 20.2413 18.4879 20.0544C18.6749 19.8675 18.9287 19.763 19.1931 19.7643C19.3604 19.7688 19.524 19.8146 19.6693 19.8976C20.1441 20.1712 20.7508 20.0094 21.0264 19.5357L21.3693 18.9643C21.502 18.7365 21.5384 18.4652 21.4705 18.2105C21.4026 17.9557 21.2359 17.7386 21.0074 17.6071C20.7789 17.4757 20.6122 17.2585 20.5443 17.0038C20.4763 16.7491 20.5128 16.4778 20.6455 16.25C20.7318 16.0993 20.8567 15.9744 21.0074 15.8881C21.4783 15.6127 21.6397 15.0095 21.3693 14.5357V14.531Z",
    fill: "white",
    stroke: "#53545C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8788,
    cy: 16.7503,
    r: 1.37143,
    fill: "white",
    stroke: "#53545C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersetting);
export default __webpack_public_path__ + "static/media/usersetting.193c96c82902d81d80fa45ba1371da91.svg";
export { ForwardRef as ReactComponent };